export default function sellerColumn() {
    return {
        name: 'seller', label: 'Seller',
        options: {
			headerAlign: 'left'
        }
    }
}